import React, { useEffect, useState } from 'react';
import Formulario from './ManoObraForm';
import LoadMask from "../../Utils/LoadMask/LoadMask";

function ManoObra(props) {
    const { loader, modulo, datos,
        listarPresupuestos, detalleProducto, buscarCliente,
        detalleOrden, registroManoObra, agregarLinea, detalleOrd,
        eliminarLinea, agregarLineaNueva, cambioD,
        modificarManoObra, eliminarLineaManoObra, clienteProyecto,
        listaTipoMO, listarTipoMO, listarActividad, listaActividad,
        listarColaboradores, listaColaborador
    } = props;        
        
    useEffect(() => {
        const { match, leer, getModulo,
            limpiarManoObra } = props;
        const id = match.params.id;
        if (id) {
            setCrear(false);
            leer(id);
        }
        let ruta = window.location.href;
        let periodo = ruta.split('/');
        getModulo(periodo[5], periodo[4]);
        //parametrosEmpresa();
        limpiarManoObra();
        listarTipoMO();
        listarActividad();
    }, [])

    const [crear, setCrear] = useState(true);

    const editar = window.location.href.includes('editar');
    let titulo = 'Crear mano de obra';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver mano de obra';
    }

    return (
        <LoadMask loading={loader} dark>
            <Formulario
                registroManoObra = {registroManoObra}
                modificarManoObra = {modificarManoObra}
                datos = {datos}
                crear = {crear}
                titulo = {titulo}
                editar = {editar}
                modulo = {modulo}
                bloqueo = {disabled}
                listarPresupuestos = {listarPresupuestos}
                detalleProducto = {detalleProducto}
                detalleOrden = {detalleOrden}
                agregarLinea = {agregarLinea}
                detalleOrd = {detalleOrd}
                eliminarLinea = {eliminarLinea}
                agregarLineaNueva = {agregarLineaNueva}
                eliminarLineaManoObra = {eliminarLineaManoObra}
                buscarCliente = {buscarCliente}
                clienteProyecto = {clienteProyecto}
                cambioD = {cambioD}
                listaTipoMO = {listaTipoMO}
                listaActividad = {listaActividad}
                listarColaboradores = {listarColaboradores}
                listaColaborador = {listaColaborador}
            />
        </LoadMask>
    );
}

export default ManoObra;